import React from 'react';

const TermsConditionsRU: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Принятие Условий</h2>
        <p className="mb-4">
          Загружая, устанавливая или используя мобильное приложение и веб-сайт GatherPlay ("Сервис"), вы соглашаетесь 
          быть связанными настоящими Условиями использования ("Условия"). Если вы не согласны с настоящими Условиями, не используйте Сервис.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Поставщик Услуг:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Компания: BIXMO SRL</li>
            <li>Адрес: Кишинев, Молдова</li>
            <li>Электронная почта: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Описание Сервиса</h2>
        <p className="mb-4">
          GatherPlay - это многопользовательская игра, где игроки разыгрывают сценарии на основе пронумерованных уровней 
          интенсивности, в то время как один игрок пытается угадать, у кого какой номер. Сервис включает:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Мобильное приложение для устройств iOS и Android</li>
          <li>Веб-приложение, доступное через браузеры</li>
          <li>Функциональность многопользовательской игры</li>
          <li>Контент карточек сценариев</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Возрастные Требования</h2>
        <p>
          GatherPlay предназначен для пользователей в возрасте от 6 лет. Пользователи младше 13 лет должны использовать 
          Сервис под родительским присмотром. Используя Сервис, вы заявляете, что соответствуете возрастным требованиям.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Поведение Пользователя</h2>
        <p className="mb-4">Вы соглашаетесь использовать Сервис ответственно и соглашаетесь НЕ:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Использовать Сервис для любых незаконных целей или в нарушение местного, государственного, национального или международного права</li>
          <li>Преследовать, оскорблять или причинять вред другим игрокам</li>
          <li>Пытаться провести обратную разработку, модифицировать или взломать приложение</li>
          <li>Использовать автоматизированные скрипты или боты для взаимодействия с Сервисом</li>
          <li>Делиться неподходящим контентом во время игры</li>
          <li>Вмешиваться в работу или нарушать Сервис или серверы</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Права Интеллектуальной Собственности</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.1 Наш Контент</h3>
        <p className="mb-4">Весь контент в GatherPlay, включая но не ограничиваясь:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Игровые механики и правила</li>
          <li>Карточки сценариев и игровой контент</li>
          <li>Программный код и алгоритмы</li>
          <li>Графика, логотипы и элементы дизайна</li>
          <li>Текст и письменные материалы</li>
        </ul>
        <p className="mb-4">принадлежит BIXMO SRL и защищен авторским правом, торговыми марками и другими законами об интеллектуальной собственности.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.2 Ваша Лицензия</h3>
        <p>
          Мы предоставляем вам ограниченную, неисключительную, непередаваемую лицензию на использование Сервиса для личных, 
          некоммерческих целей в соответствии с настоящими Условиями.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Премиум-функции и Платежи</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.1 Покупка в Приложении</h3>
        <p className="mb-4">
          GatherPlay предлагает премиум-обновление, доступное через покупку в приложении, которое убирает рекламу. 
          Это единовременная покупка, привязанная к вашей учетной записи магазина приложений.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.2 Возврат Средств</h3>
        <p className="mb-4">
          Политика возврата средств регулируется соответствующими политиками магазинов приложений (Apple App Store 
          или Google Play Store). Мы не обрабатываем возврат средств напрямую.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.3 Изменения Цен</h3>
        <p>
          Мы оставляем за собой право изменять цену премиум-функций в любое время, хотя изменения не повлияют на 
          существующие покупки.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Реклама</h2>
        <p>
          Бесплатная версия GatherPlay отображает рекламу. Используя бесплатную версию, вы соглашаетесь видеть эту рекламу. 
          Реклама предоставляется сторонними сетями, и мы не несем ответственности за их контент.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Данные и Конфиденциальность</h2>
        <p>
          Ваша конфиденциальность важна для нас. Пожалуйста, ознакомьтесь с нашей Политикой Конфиденциальности, которая 
          объясняет, как мы собираем, используем и защищаем вашу информацию. Политика Конфиденциальности включена в настоящие Условия по ссылке.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Доступность Сервиса</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.1 Доступность</h3>
        <p className="mb-4">
          Мы стремимся поддерживать Сервис доступным 24/7, но не гарантируем непрерывный доступ. Сервис может быть 
          временно недоступен по причине:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Планового обслуживания</li>
          <li>Технических трудностей</li>
          <li>Факторов вне нашего контроля</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.2 Обновления</h3>
        <p>
          Мы можем время от времени обновлять Сервис для добавления функций, исправления ошибок или улучшения производительности. 
          Некоторые обновления могут потребоваться для продолжения использования Сервиса.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Ограничение Ответственности</h2>
        <p className="mb-4">В максимальной степени, разрешенной применимым правом:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Сервис предоставляется "как есть" без гарантий любого вида</li>
          <li>Мы не несем ответственности за любой косвенный, случайный, специальный или последующий ущерб</li>
          <li>Наша общая ответственность не должна превышать сумму, которую вы заплатили за премиум-функции (если таковые имеются)</li>
          <li>Мы не несем ответственности за любую потерю данных или прерывание работы сервиса</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Возмещение Ущерба</h2>
        <p>
          Вы соглашаетесь возместить ущерб и оградить BIXMO SRL от любых претензий, ущерба или расходов, возникающих 
          в результате вашего использования Сервиса или нарушения настоящих Условий.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Прекращение</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.1 Прекращение Вами</h3>
        <p className="mb-4">Вы можете прекратить использование Сервиса в любое время, удалив приложение.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.2 Прекращение Нами</h3>
        <p className="mb-4">
          Мы можем прекратить или приостановить ваш доступ к Сервису в любое время, с причиной или без, 
          с уведомлением или без такового.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.3 Последствия Прекращения</h3>
        <p>
          При прекращении ваше право на использование Сервиса немедленно прекращается. Положения, которые должны 
          пережить прекращение (включая права интеллектуальной собственности, ограничение ответственности и возмещение ущерба) 
          будут продолжать действовать.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Применимое Право</h2>
        <p>
          Настоящие Условия регулируются и толкуются в соответствии с законами Республики Молдова, без учета 
          их положений о коллизии права.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Разрешение Споров</h2>
        <p>
          Любые споры, возникающие из настоящих Условий или использования Сервиса, будут разрешаться через обязательный 
          арбитраж в соответствии с законами Республики Молдова или в компетентных судах Кишинева, Молдова.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Изменения в Условиях</h2>
        <p className="mb-4">Мы оставляем за собой право изменять настоящие Условия в любое время. Мы уведомим пользователей о существенных изменениях:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Публикуя обновленные Условия в приложении</li>
          <li>Обновляя дату "Последнего Обновления"</li>
          <li>Предоставляя внутриприложенческое уведомление для значительных изменений</li>
        </ul>
        <p>Продолжение использования Сервиса после изменений означает принятие обновленных Условий.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Делимость</h2>
        <p>
          Если какое-либо положение настоящих Условий будет признано неисполнимым, остальная часть Условий 
          останется в полной силе и действии.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Контактная Информация</h2>
        <p className="mb-4">По вопросам о настоящих Условиях и Положениях обращайтесь к нам:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Электронная почта: gatherplay.application@gmail.com</li>
          <li>Компания: BIXMO SRL, Кишинев, Молдова</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">18. Полное Соглашение</h2>
        <p>
          Настоящие Условия вместе с нашей Политикой Конфиденциальности составляют полное соглашение между вами 
          и BIXMO SRL относительно использования Сервиса.
        </p>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Используя GatherPlay, вы подтверждаете, что прочитали, поняли и соглашаетесь быть связанными настоящими 
          Условиями и Положениями.
        </p>
      </div>
    </div>
  );
};

export default TermsConditionsRU;